










import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    companion: {
      type: Array as () => Array<{ number: string; index: string; 'product-name': string }>,
      required: false,
      default: undefined,
    },
  },
  setup({ companion }) {
    const sortedCompanions = Object.values(companion).sort((a: any, b: any) => a.number - b.number)
    return { sortedCompanions }
  },
})
